import { useTranslation } from 'react-i18next';
import Dialog from '../../components/Dialog/Dialog';
import { HorizontalSpaced } from '../../components/Spaced/Spaced';
import useCart from '../Cart/useCart';
import ProductDetails from './ProductDetails';

function ProductList({ onClose, show }: ProductListProps) {
  const { products } = useCart();
  const { t } = useTranslation();

  return (
    <Dialog onClose={onClose} show={show} title={t('selectedProduct', { count: products.length })}>
      <HorizontalSpaced>
        {products.map((product) => (
          <ProductDetails product={product} key={product.name} />
        ))}
      </HorizontalSpaced>
    </Dialog>
  );
}

export default ProductList;
